import React, { useState } from 'react';
import FaqItem from './FaqItem';
import styles from './landingFaq.module.css';

export interface FaqItemData {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: readonly FaqItemData[];
}

const FaqAccordion: React.FC<FaqAccordionProps> = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index: number) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? -1 : index));
  };

  return (
    <div className={styles.accordion}>
      {items.map((item, index) => (
        <FaqItem
          key={item.question}
          item={item}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
        />
      ))}
    </div>
  );
};

export default FaqAccordion;
